module.exports = __webpack_public_path__ + "img/stick_patrimoine_chateau.0cb82bb5.svg";